export default {"src":"/gb/en/_next/static/media/BBA_Winner_Best_savings_provider.66c760bc.svg","height":64,"width":236,"blurWidth":0,"blurHeight":0};